import React from 'react';

function ServiceDetailModal({ service, onClose, onBook }) {
  if (!service) return null;
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>✕</button>
        <h2 className="modal-title">{service._name}</h2>
        <div className="modal-description" dangerouslySetInnerHTML={{ __html: service._fullDesc }} />
        <div className="modal-details">
          <div className="modal-detail-item">
            <span className="modal-detail-label">Price</span>
            <span className="modal-detail-value">{service._price > 0 ? `$${service._price}` : 'Price varies'}</span>
          </div>
          <div className="modal-detail-item">
            <span className="modal-detail-label">Duration</span>
            <span className="modal-detail-value">{service.duration} Mins</span>
          </div>
        </div>
        <button className="modal-book-btn" onClick={() => { onClose(); onBook(service); }}>
          CONTINUE BOOKING
        </button>
      </div>
    </div>
  );
}

export default ServiceDetailModal;
